import styled, { css } from "styled-components";
import tw from "twin.macro";

import { VisibleFromBreakpoint } from "./EntityProperty";
import { Card } from "../Card";
import { PaperStyles } from "../Paper/Styles";

export const StyledEntityCard = styled(Card)<{
  $renderAs: string;
  $gap?: number;
  $background?: string;
  $isCollection?: boolean;
}>`
  line-height: 1.375;
  ${({ $renderAs }) =>
    $renderAs === "list" &&
    css`
      display: flex;
      flex-direction: row;
      align-items: center;
      min-height: 48px;
      margin-bottom: 4px;
      justify-content: space-between;
      padding: 0 16px 0 16px;
    `}

  ${({ $renderAs }) =>
    $renderAs === "grid" &&
    css`
      display: flex;
      flex-direction: column;
      position: relative;
      padding: 20px 24px;
      height: 280px;
    `}


  ${(props) =>
    props.$background &&
    css`
      background-color: ${props.$background};
    `}

  ${({ $isCollection, $background }) =>
    $isCollection &&
    css`
      &::after {
        display: block;
        content: "";
        position: absolute;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        transform: rotate(-3deg);
        z-index: -1;
        ${PaperStyles};
        background-color: ${$background};
      }
    `}
`;
StyledEntityCard.displayName = "StyledEntityCard";

export const StyledEntityProperty = styled("div")<{
  $renderAs?: string;
  $order?: number;
  $width?: number | string;
  $visibleFromBreakpoint?: VisibleFromBreakpoint;
}>`
  ${({ $renderAs, $width }) =>
    $renderAs === "list" &&
    css`
      display: flex;
      align-items: center;
      min-width: 24px;
      flex: ${$width ? "initial" : 1};
    `}

  ${(props) =>
    props.$renderAs === "list" &&
    props.$order &&
    css`
      order: ${props.$order};
    `}

  ${(props) =>
    props.$renderAs === "list" &&
    props.$width &&
    css`
      width: ${props.$width};
    `}
  ${({ $visibleFromBreakpoint }) =>
    $visibleFromBreakpoint &&
    css`
      ${tw`tw-hidden`}
    `}
  ${({ $visibleFromBreakpoint }) =>
    $visibleFromBreakpoint === "sm" &&
    css`
      ${tw`sm:tw-flex`}
    `}
  ${({ $visibleFromBreakpoint }) =>
    $visibleFromBreakpoint === "md" &&
    css`
      ${tw`md:tw-flex`}
    `}
  ${({ $visibleFromBreakpoint }) =>
    $visibleFromBreakpoint === "lg" &&
    css`
      ${tw`lg:tw-flex`}
    `}
  ${({ $visibleFromBreakpoint }) =>
    $visibleFromBreakpoint === "xl" &&
    css`
      ${tw`xl:tw-flex`}
    `}
  ${({ $visibleFromBreakpoint }) =>
    $visibleFromBreakpoint === "2xl" &&
    css`
      ${tw`2xl:tw-flex`}
    `}
`;

StyledEntityProperty.displayName = "StyledEntityProperty";

export const StyledEntityGroup = styled("div")<{
  $renderAs: string;
  $gap?: number;
}>`
  ${({ $renderAs, $gap }) =>
    $renderAs === "grid" &&
    css`
      display: grid;
      grid-gap: ${$gap ? `${$gap}px` : "initial"};
      grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
    `}
  ${(props) =>
    props.$renderAs === "list" &&
    css`
      display: flex;
      flex-direction: column;
    `}
`;
StyledEntityGroup.displayName = "StyledEntityGroup";

export const StyledEntityActions = styled("div")<{ $renderAs?: string }>`
  display: flex;
  flex-direction: column;
  align-items: center;

  ${({ $renderAs }) =>
    $renderAs === "grid" &&
    css`
      position: absolute;
      right: 16px;
      top: 20px;
    `}

  ${({ $renderAs }) =>
    $renderAs === "list" &&
    css`
      justify-self: flex-end;
    `}
`;
